import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Task } from "@/types";
import Group from "@/components/atoms/Group";
import Stack from "@/components/atoms/Stack";
import SVGAsset from "@/components/atoms/SVGAsset/SVGAsset";
import Text from "@/components/atoms/Text";
import CTA from "@/components/atoms/CTA";

import styles from "./styles.module.css";

interface Props {
  task: Task;
  onClose: () => void;
}

/**
 * Panel for COLLECTION tasks. The collection itself is scheduled on the containers queue,
 * so the panel just hands the user off to the right container row — `task.connected` is
 * the containerId.
 */
function CollectionTask({ task, onClose }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const schedulePickup = () => {
    onClose();
    navigate(`/containers/collections?containerId=${task.connected}`);
  };

  return (
    <Stack className="full flex col between h-100 py-10">
      <Group gap="20px" align="center" className={styles.taskHeader}>
        <SVGAsset name="logstics" />
        <Text size="md" display="technical" tt="uppercase" strong={true}>
          {t("enumerables:taskTypes.COLLECTION")}
        </Text>
      </Group>

      <Stack className={styles.tabPanelPadded} align="center" pt={30}>
        <CTA intent="primary" onClick={schedulePickup} data-testid="collection-task-schedule-btn">
          {t("tasks:schedulePickup")}
        </CTA>
      </Stack>

      <Group className={styles.tabActionGroup} p={15} gap={16} align="center" justify="flex-end">
        <CTA intent="secondary" onClick={() => onClose()}>
          {t("actions:close")}
        </CTA>
      </Group>
    </Stack>
  );
}

export default CollectionTask;
